import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, ListItemText, Stack, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MyTable from '../../../../components/MyTable';
import Form from './Form';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Link } from 'react-router-dom';

const DataBendahara = () => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [deleting, setDeleting] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [edit, setEdit] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [dialogData, setDialogData] = useState({});

    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            filterable: false,
            hideable: false,
            width: 150,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                const onDelete = (e) => {
                    setDeleting(true);
                    const frmData = {
                        _method: 'DELETE',
                        username: params.row.username
                    }

                    Swal.fire({
                        title: 'Hapus Data?',
                        text: "Operasi tidak dapat Dikembalikan!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showLoaderOnConfirm: true,
                        confirmButtonText: 'Ya, Hapus!',
                        cancelButtonText: 'Batal',
                        preConfirm: () => {
                            return axios.post(
                                base_url + '/admin/bendahara/delete',
                                frmData,
                                {
                                    headers: {
                                        'Authorization': `Bearer ${decryptedUser.token}`,
                                        'content-type': 'multipart/form-data'
                                    }
                                })
                                .then((response) => {
                                    requestData();
                                    return response.data
                                })
                                .catch((error) => {
                                    if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                                        logOut();
                                    }
                                    else {
                                        console.log(error.response);
                                        Swal.showValidationMessage(
                                            `Request failed: ${error.response.statusText}`
                                        )
                                    }
                                })
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        console.log(result);
                        if (result.isConfirmed) {
                            Swal.fire(
                                'Selesai!',
                                result.value,
                                'success'
                            )
                        }
                    })

                }

                const onEdit = () => {
                    console.log(params.row);
                    setEdit(params.row)
                }

                const onOption = (params) => {
                    handleOpenDialog(params)
                }

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Hapus">
                            <IconButton aria-label="delete" color='error' onClick={onDelete}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <IconButton aria-label="edit" color="info" onClick={onEdit}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Lihat Data">
                            <IconButton aria-label="confirm" color='success' onClick={() => onOption(params.row)}>
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            },
        },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 300
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        },
        { field: 'nama', headerName: 'Nama', width: 350 },
        {
            field: 'nip',
            headerName: 'NIP',
            minWidth: 250,
        },
        {
            field: 'username',
            headerName: 'Username',
            minWidth: 200,
            hide: true
        },
        {
            field: 'password',
            headerName: 'Password',
            minWidth: 200,
            hide: true
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 250,
        }

    ];

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting, edit])

    const requestData = () => {
        setTableLoading(true)
        axios.get(
            base_url + '/admin/bendahara',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                setTableData(response.data)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setTableLoading(false)
            })
    }

    const handleOpenDialog = (params) => {
        setOpenDialog(true);
        setDialogData(params);
        console.log(params);
    };

    const handleCloseDialog = (event, reason) => {
        if (reason && reason === "backdropClick" && "escapeKeyDown")
            return;
        setOpenDialog(false);
    };

    // const descriptionElementRef = useRef(null);

    return (
        <>
            {edit === null ?
                <Card>
                    <CardHeader
                        title="Bendahara"
                        action={
                            <Button
                                variant="contained"
                                endIcon={<AddCircleOutlineIcon color='white' />}
                                to="/admin/bendahara/add"
                                component={Link}
                            >
                                Tambah
                            </Button>
                        }
                    />
                    <CardContent>
                        <MyTable
                            rows={tableData}
                            columns={columns}
                            row_id={(row) => row.username}
                            isLoading={tableLoading}
                        />
                    </CardContent>
                </Card>
                :
                <Card>
                    <CardHeader
                        title={
                            <Typography variant='h5'>Edit Bendahara</Typography>
                        }
                        avatar={
                            <Tooltip title="Kembali">
                                <IconButton variant="outlined" onClick={() => {
                                    setEdit(null)
                                }} color="error"><ArrowBackIcon /></IconButton>
                            </Tooltip>
                        }
                    />
                    <CardContent>
                        <Form edit={edit} setEdit={setEdit} />
                    </CardContent>
                </Card>
            }
            <Dialog
                fullWidth={true}
                maxWidth="md"
                open={openDialog}
                onClose={handleCloseDialog}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                disableEscapeKeyDown
            >
                <DialogTitle id="scroll-dialog-title">Detail Bendahara</DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <ListItemText primary="NIP" secondary={dialogData.nip} />
                        </Grid>
                        <Grid item xs={12}>
                            <ListItemText primary="Nama" secondary={dialogData.nama} />
                        </Grid>
                        <Grid item xs={12}>
                            <ListItemText primary="Username" secondary={dialogData.username} />
                        </Grid>
                        <Grid item xs={12}>
                            <ListItemText primary="Password" secondary={dialogData.password} />
                        </Grid>
                        <Grid item xs={12}>
                            <ListItemText primary="OPD" secondary={dialogData.opd} />
                        </Grid>
                        <Grid item xs={12}>
                            <ListItemText primary="Status" secondary={dialogData.status} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Tutup</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DataBendahara